import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { QRCodeCanvas } from 'qrcode.react';
import { isMobile } from 'react-device-detect';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import axios, { AxiosError, CancelTokenSource } from 'axios';
import Select, { components, InputProps }  from 'react-select';


interface ServiceObjectVm {
    id: number;
    parentId: number | null;
    name: string | null;
    fullName: string | null;
    serviceObjectTypeId: number;
    typeName: string | null;
    shortTypeName: string | null;
    searchVectorPattern: string | null;
    businessUnitId: number;
    level: number;

}



type PaymentProps = RouteComponentProps<{}>;

interface PaymentState {
    paymentUrl: string;
    isOpenMenu: boolean;
    isSearch: boolean;
    selectServiceObject: ServiceObjectVm | null;
    serviceObjects: ServiceObjectVm[];

}


class Payment extends React.PureComponent<PaymentProps, PaymentState>{


    constructor(props: PaymentProps) {
        super(props);
        this.state = {
            paymentUrl: "https://qr.nspk.ru/BD10000V475K6AHK85C839K7D49VJJDG?type=02&bank=100000000022&sum=24000&cur=RUB&crc=8EEF%22,%22canBeRestarted%22:false,%22hasPaymentStarted%22:false%7D%7D",
            isOpenMenu: false,
            isSearch: false,
            selectServiceObject: null,
            serviceObjects: []
        }

        this.CloseMenu = this.CloseMenu.bind(this);
        this.OpenMenu = this.OpenMenu.bind(this);
        this.GetServiceObjects = this.GetServiceObjects.bind(this);
        this.OnChangeValue = this.OnChangeValue.bind(this);
        this.OnChangeInputValue = this.OnChangeInputValue.bind(this);

        this.lastUpdate=Date.now()-2000;

        
    }

    private lastUpdate : number


    private CloseMenu(): void {
        this.setState({ isOpenMenu: false })
    }

    private OpenMenu(): void {
        this.setState({ isOpenMenu: true })
    }


    public async GetServiceObjects(search: string, parentId: number | null): Promise<ServiceObjectVm[]> {

        return await axios.get<ServiceObjectVm[]>(`https://localhost:7284/WeatherForecast?search=${search}${parentId!==null?`&parentId=${parentId}`:"" } `)
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return []
                }
                return []
            })

    }


    public async OnChangeValue(serviceObject: ServiceObjectVm | null) {

        this.setState({
            selectServiceObject: serviceObject,
            serviceObjects:[]
        })

       

    }


    public async OnChangeInputValue(search: string,serviceObject: ServiceObjectVm | null) {

        this.lastUpdate=Date.now();
        let local =this.lastUpdate;
        setTimeout(async() => {
            if (search.length>0 && local===this.lastUpdate)
            {
                this.setState({
                    isSearch: true,
                    isOpenMenu:false,
                    serviceObjects: []
                })
                var result = await this.GetServiceObjects(search, serviceObject?.id || null)
        
                this.setState({
                    serviceObjects: result,
                    isSearch: false,
                    isOpenMenu: true
                })
            }
            
        }, 1000);


      
        
       

    }


    render(): React.ReactNode {

        return <React.Fragment>

            <Row className='d-flex justify-content-center mt-5'>


                <Select
                    components={{
                        MultiValueContainer: (props) => <span style={{ maxWidth: "70%", marginRight: "0.5rem", paddingRight: "0.5rem", borderRight: "0.1rem solid #d5d8da" }}>
                            {props.data.fullName}
                        </span>,
                        DropdownIndicator: (props) => <React.Fragment />,
                        IndicatorSeparator: (props) => <React.Fragment />,
                        /* Input: (props: InputProps<ServiceObjectAddressLayout, true>) => {
                             if (props.isHidden) {
                               return <components.Input {...props} />;
                             }
                             return (
                                   <components.Input {...props}  inputClassName="Test"/>
                            );}*/
                    }}
                    isMulti
                    onBlur={this.CloseMenu}
                    onFocus={this.OpenMenu}
                    menuShouldBlockScroll={false}
                    // menuPosition={'fixed'}
                    placeholder="Выбор адреса"
                    isClearable={true}
                    loadingMessage={e => "Поиск..."}
                    noOptionsMessage={e => "Данные отсутствуют"}
                    menuIsOpen={this.state.isOpenMenu}
                    blurInputOnSelect={false}
                    
                    isLoading={this.state.isSearch}
                    styles={{
                        container: (provided) => ({
                            ...provided,
                            minHeight: '1px',
                            width: "100%"
                        }),
                        control: (provided, props) => ({
                            ...provided,
                            background: "#F8F8F8",
                            borderRadius: "0.5rem",
                            minHeight: "4rem",
                            padding: "0 1rem",
                            boxShadow: "none"

                        }),
                        menu: (provided) => ({
                            ...provided,
                            background: "#F8F8F8",
                        }),
                        option: (provided, props) => ({
                            ...provided,
                            "&:hover": { background: "#d5d8da" },

                            borderBottom: "0.1rem solid #d5d8da",
                            background: props.isSelected ? "#d5d8da" : "none",
                            color: "black"

                        }),
                        input: (provided, props) => ({
                            ...provided,
                            color: "black",
                            maxWidth: "1rem"
                        }),

                        valueContainer: (provided, props) => ({
                            ...provided,
                        }),
                        multiValue: (provided, props) => ({
                            ...provided,
                            marginRight: "1rem",

                        }),
                    }}

                    value={this.state.selectServiceObject ? this.state.selectServiceObject : []}
                    getOptionLabel={option => option.fullName || '--'}
                    getOptionValue={option => option.id.toString()}
                    filterOption={(option, string) => {
                       
                        return true;
                       /* let serviceObeject = option.data as ServiceObjectVm;
                        if (serviceObeject) {
                            return serviceObeject.name?.toLowerCase()?.includes(string?.toLowerCase()) === true
                        }
                        else {
                            return false;
                        }*/
                    }}
                    onInputChange={e=>{
                        if (e!=="")
                        {
                            this.OnChangeInputValue(e,this.state.selectServiceObject);
                        }
                    }}
                    onChange={async (value, action) => {
                    
                        if (Array.isArray(value) &&
                            !this.state.isSearch) {
                            let serviceObject = value[value.length - 1] as ServiceObjectVm;
                            if (serviceObject) {
                                await this.OnChangeValue(serviceObject);
                            }
                            else if (!serviceObject &&
                                action.action === "clear") {
                                await this.OnChangeValue(null);
                            }
                           
                        }
                    }}
                    options={this.state.serviceObjects}
                />



            </Row>

        </React.Fragment>

    }
}



export default withRouter(Payment)